@if(!isAobScreen){ <ng-container *transloco="let t; prefix: 'shared.checkout.checkout-result'">
    <main *ngIf="(order$ | async)" class="flex-1 flex flex-col mt-[5px]">
        <section class="flex-1 flex justify-center items-center container pb-[108px] pt-[72px]">
            <div class="flex flex-col gap-12 flex-1 max-w-[1024px]">
                <div class="text-start">
                    <h1 class="h1 font-sm text-black leading-snug" [innerHTML]="t('header')"></h1>
                    <h2 class="h2 text-gray-900 text-[26px]"> <span>{{t('infoText-1')}} </span>
                        <a [localizedRouterLink]="'/my-profile/requests'"
                            class="h2 font-semibold text-primary-900 cursor-pointer underline">{{t('infoText-myRequests')}}</a>
                        <span> {{t('infoText-2')}}</span>
                    </h2>
                </div>
                <div class="bg-gray-100 p-6 flex flex-col gap-6 rounded-lg">
                    <div class="flex justify-between items-center">
                        <div class="text-black font-semibold leading-tight">
                            <span class="rfs:text-xl">{{t('labels.orderId')}}</span>
                            <span class="block rfs:text-[2rem]">{{ order?.number }}</span>
                        </div>
                        <div class="flex rounded-full h-8 w-8 bg-primary-500 justify-center items-center">
                            <i class="icon-check text-white text"></i>
                        </div>
                    </div>
                    <hr>
                    <p class="max-w-[380px]" [innerHTML]="t('aob-infoText')"></p>
                </div>
                <app-step-review [cardData]="cardData" [orderData]="order"
                    [isFromCompleteStep]="true"></app-step-review>
            </div>
        </section>
    </main>
    <app-navigation-buttons [HideSkip]="true" [HidePrevious]="true" (NextButtonClicked)="onNextClick()"
        [CustomNextTitle]="t('titles.myRequests')" [HideNextArrow]="true"></app-navigation-buttons>
</ng-container> } @else{ <div class="flex flex-grow container py-8"
    *transloco="let t; prefix: 'shared.checkout.checkout-result'">
    <div class="md:flex flex-grow container py-8">
        <div class="flex-grow flex lg:flex-row flex-col lg:items-start items-center justify-center">
            <div class=" flex flex-1 justify-center">
                <div class="flex flex-col rfs:gap-16">
                    <div class="flex flex-col gap-6 max-w-[596px]">
                        <h1 class="h1 font-sm text-black leading-snug" [innerHTML]="t('aob-header')"></h1>
                        <h2 class="text-gray-900 text-[26px] font-normal" [innerHTML]="t('aob-description')"></h2>
                        <p class="text-gray-900" [innerHTML]="t('aob-infoText')"></p>
                    </div>
                    <ng-container>
                        <div>
                            <div class="flex flex-col w-full gap-6 md:flex-row">
                                <button [disabled]="!propertyId" (click)="goToBrokerage()" role="button"
                                    class="btn-primary no-wrap">{{t('anchors.gotToBrokerage')}}</button>
                                <button [disabled]="!propertyId" (click)="goToListing()" role="button"
                                    class="btn-secondary">{{t('anchors.goToListing')}}</button>
                            </div>
                            <section class="mt-10 w-full">
                                <app-experts-callback [modalComponent]="'GeneralCallbackModal'"
                                    [isAob]="true"></app-experts-callback>
                            </section>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="flex-1 h-[340.39px] w-[490px] on-boarding-bg-1"></div>
        </div>
    </div>
</div> }